import type { AppRegistryType } from "../schemas/AppRegistrySchemas.ts";
import type { ResourceAdapterToAdapterQueryKeysType } from "../util/index.ts";
import { Resources } from "../util/index.ts";
import { restAPI } from "./api.ts";

export const AppRegistryAdapter: AppRegistryAdapterType = {
  /**
   * List the names of the custom apps the caller can access. Carbon Hub only
   * includes an app when both the caller's company and the caller are granted it.
   * @see {@link https://staging-carbon-hub-api.s3.us-west-2.amazonaws.com/openapi/index.html#/users/list_accessible_custom_apps}
   */
  listAccessibleCustomApps: () =>
    restAPI.nodeAPI.GET<AppRegistryType>({ endpoint: "/app_registry" }),
};

export type AppRegistryAdapterType = {
  listAccessibleCustomApps: () => Promise<AppRegistryType>;
};

export const AppRegistryAdapterQueryKeys: ResourceAdapterToAdapterQueryKeysType<AppRegistryAdapterType> =
  {
    listAccessibleCustomApps: () =>
      [Resources.APP_REGISTRY, "listAccessibleCustomApps"] as const,
  };
